(() => {
  const config = document.querySelector('[data-ssg-addons-redirect]');
  if (!config || window.Shopify?.designMode || window.ssgAddonsRedirectInstalled) return;
  const page = new URL(config.dataset.page, location.origin);
  if (page.origin !== location.origin || !/\/pages\/[^/]+\/?$/.test(page.pathname)) return;
  const cartPath = new URL(config.dataset.cart, location.origin).pathname;
  const checkoutPath = cartPath.replace(/\/cart\/?$/, '/checkout');
  const onAddonsPage = () => document.querySelector('[data-ssg-addons-page]') || location.pathname.replace(/\/$/, '') === page.pathname.replace(/\/$/, '');
  const nativeForms = new WeakSet();
  let routing = false;
  window.ssgAddonsRedirectInstalled = true;

  document.addEventListener('click', event => {
    if (onAddonsPage() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor || anchor.hasAttribute('download') || (anchor.target && anchor.target !== '_self')) return;
    const target = new URL(anchor.href, location.origin);
    if (target.origin !== location.origin || target.pathname !== checkoutPath || target.search || target.hash) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(page.href);
  }, true);

  document.addEventListener('submit', async event => {
    const form = event.target;
    const button = event.submitter;
    if (onAddonsPage() || event.defaultPrevented || nativeForms.has(form) || !(form instanceof HTMLFormElement)) return;
    const action = new URL(button?.hasAttribute('formaction') ? button.formAction : form.action, location.origin);
    if (action.origin !== location.origin || action.pathname !== cartPath || button?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (routing) return;
    routing = true;
    const body = new FormData(form);
    body.delete('checkout');
    body.delete('return_to');
    button.disabled = true;
    try {
      const response = await fetch(config.dataset.update, {method: 'POST', body, headers: {Accept: 'application/json'}, signal: AbortSignal.timeout(8000)});
      if (!response.ok) throw new Error('Cart update failed');
      const cart = await response.json();
      if (!cart.item_count) throw new Error('Empty cart');
      location.assign(page.href);
    } catch {
      nativeForms.add(form);
      button.disabled = false;
      form.requestSubmit(button);
    } finally {
      routing = false;
    }
  }, true);
})();
